module.exports = __webpack_public_path__ + "img/logo_bank_bni.92fe534b.png";